import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import Box from "@mui/material/Box";
import LanguageContext from "components/LanguageContext";
import PropTypes from "prop-types";
import React, { useCallback, useContext, useState } from "react";
import t from "utils/locales/translation.json";

const ExpansionText = (props) => {
  const { reducedLabel, expandedLabel, text, defaultExpanded = false, labelBefore = false, ...others } = props;

  const { language } = useContext(LanguageContext);

  const [isExpanded, setIsExpanded] = useState(defaultExpanded);

  const handleClickExpand = useCallback(() => {
    setIsExpanded(!isExpanded);
  }, [isExpanded]);

  const Icon = isExpanded ? ExpandLess : ExpandMore;

  return (
    <Box {...others} sx={{ "& button": { color: "primary.main", p: 0, "&:hover": { bgcolor: "transparent" } } }}>
      {!labelBefore && <Box sx={{ display: isExpanded ? "block" : "none" }}>{text}</Box>}
      <button type="button" aria-expanded={isExpanded ? "true" : "false"} onClick={handleClickExpand} tabIndex={0}>
        {isExpanded ? expandedLabel : reducedLabel}
        <Icon
          title={isExpanded ? expandedLabel : reducedLabel}
          isHidden={false}
          aria-label={isExpanded ? t[language].common.close : t[language].common.open}
          sx={{ ml: 0.5, verticalAlign: "middle", fontSize: "1.2em" }}
        />
      </button>
      {labelBefore && <Box sx={{ display: isExpanded ? "block" : "none" }}>{text}</Box>}
    </Box>
  );
};

ExpansionText.propTypes = {
  reducedLabel: PropTypes.string.isRequired,
  expandedLabel: PropTypes.string.isRequired,
  text: PropTypes.node.isRequired,
  defaultExpanded: PropTypes.bool,
  labelBefore: PropTypes.bool,
};

export default ExpansionText;
